import script from "./PatientDemographics.vue?vue&type=script&setup=true&lang=js"
export * from "./PatientDemographics.vue?vue&type=script&setup=true&lang=js"

import "./PatientDemographics.vue?vue&type=style&index=0&id=09affb9e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-09affb9e"]])

export default __exports__